import { a11yProps } from "../../../../../../../features/TabPanel/TabPanel.partial";
import { Tab, TabProps, useTheme } from "@mui/material";

interface BookingServiceCustomTabProps extends Omit<TabProps, "label"> {
  index: number;
  "data-testid"?: string;
}

export function BookingServiceCustomTab({
  index,
  sx,
  ...rest
}: Readonly<BookingServiceCustomTabProps>) {
  const theme = useTheme();

  return (
    <Tab
      {...rest}
      data-testid={rest["data-testid"]}
      value={index}
      {...a11yProps(index)}
      sx={{
        fontWeight: theme.typography.fontWeightRegular,
        "&.Mui-selected": {
          color:
            theme.palette.mode === "dark"
              ? `${theme.palette.getContrastText(theme.palette.background.paper)} !important`
              : theme.palette.primary.main,
          fontWeight: `${theme.typography.fontWeightBold} !important`
        },
        ...sx // allow overrides from parent
      }}
    />
  );
}
